// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedditSquareFilledSvg from "@ant-design/icons-svg/es/asn/RedditSquareFilled";
import AntdIcon from '../components/AntdIcon';

var RedditSquareFilled = function RedditSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedditSquareFilledSvg
  }));
};

RedditSquareFilled.displayName = 'RedditSquareFilled';
export default React.forwardRef(RedditSquareFilled);